export default __webpack_public_path__ + "static/media/DataOutputs.516cd63c.svg";